import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import arTranslation from './locales/ar.json';
import caTranslation from './locales/ca.json';
import csTranslation from './locales/cs.json';
import daTranslation from './locales/da.json';
import deTranslation from './locales/de.json';
import elTranslation from './locales/el.json';
import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';
import fiTranslation from './locales/fi.json';
import frTranslation from './locales/fr.json';
import heTranslation from './locales/he.json';
import hiTranslation from './locales/hi.json';
import hrTranslation from './locales/hr.json';
import huTranslation from './locales/hu.json';
import idTranslation from './locales/id.json';
import itTranslation from './locales/it.json';
import jsTranslation from './locales/js.json'; // Bu dosya adı 'js' için
import koTranslation from './locales/ko.json';
import msTranslation from './locales/ms.json';
import nbTranslation from './locales/nb.json';
import nlTranslation from './locales/nl.json';
import plTranslation from './locales/pl.json';
import ptBRTranslation from './locales/pt-BR.json';
import ptPTTranslation from './locales/pt-PT.json';
import roTranslation from './locales/ro.json';
import ruTranslation from './locales/ru.json';
import skTranslation from './locales/sk.json';
import svTranslation from './locales/sv.json';
import trTranslation from './locales/tr.json';
import tvTranslation from './locales/tv.json'; // Bu dosya adı 'tv' için
import ukTranslation from './locales/uk.json';
import viTranslation from './locales/vi.json';
import zhHansTranslation from './locales/zh-Hans.json';
import zhHantTWTranslation from './locales/zh-Hant-TW.json';

const resources = {
  ar: {
    translation: arTranslation,
  },
  ca: {
    translation: caTranslation,
  },
  cs: {
    translation: csTranslation,
  },
  da: {
    translation: daTranslation,
  },
  de: {
    translation: deTranslation,
  },
  el: {
    translation: elTranslation,
  },
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fi: {
    translation: fiTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  he: {
    translation: heTranslation,
  },
  hi: {
    translation: hiTranslation,
  },
  hr: {
    translation: hrTranslation,
  },
  hu: {
    translation: huTranslation,
  },
  id: {
    translation: idTranslation,
  },
  it: {
    translation: itTranslation,
  },
  js: {
    // 'js.json' dosyası için 'js' kodu kullanılmıştır
    translation: jsTranslation,
  },
  ko: {
    translation: koTranslation,
  },
  ms: {
    translation: msTranslation,
  },
  nb: {
    translation: nbTranslation,
  },
  nl: {
    translation: nlTranslation,
  },
  pl: {
    translation: plTranslation,
  },
  'pt-BR': {
    // 'pt-BR.json' dosyası için 'pt-BR' kodu kullanılmıştır
    translation: ptBRTranslation,
  },
  'pt-PT': {
    // 'pt-PT.json' dosyası için 'pt-PT' kodu kullanılmıştır
    translation: ptPTTranslation,
  },
  ro: {
    translation: roTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
  sk: {
    translation: skTranslation,
  },
  sv: {
    translation: svTranslation,
  },
  tr: {
    translation: trTranslation,
  },
  tv: {
    translation: tvTranslation,
  },
  uk: {
    translation: ukTranslation,
  },
  vi: {
    translation: viTranslation,
  },
  'zh-Hans': {
    // 'zh-Hans.json' dosyası için 'zh-Hans' kodu kullanılmıştır
    translation: zhHansTranslation,
  },
  'zh-Hant-TW': {
    // 'zh-Hant-TW.json' dosyası için 'zh-Hant-TW' kodu kullanılmıştır
    translation: zhHantTWTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      // Dil arama sırasını güncelliyoruz:
      // 1. Tarayıcı (navigator)
      // 2. URL Sorgu Dizesi (querystring)
      // 3. Çerez (cookie)
      // 4. Yerel Depolama (localStorage)
      order: ['querystring', 'cookie', 'navigator', 'localStorage'],

      // URL'deki dil parametresinin anahtarını 'hl' olarak ayarlıyoruz (örneğin: ?hl=tr)
      lookupQuerystring: 'hl',

      caches: ['cookie'],
      lookupCookie: 'i18next',
      cookieOptions: { path: '/', sameSite: 'strict' },
    },

    fallbackLng: 'tr',

    interpolation: {
      escapeValue: false,
    },
    ns: ['translation'],
    defaultNS: 'translation',
  });
export default i18n;
